const getTranslationOrFallback = (t, key, fallback) => {
  const translated = t(key);
  return translated === key ? fallback : translated;
};

const normalizeFieldName = (field) => {
  return field
    .replaceAll('.', '_')
    .replaceAll('*', 'item')
    .replaceAll('[', '_')
    .replaceAll(']', '');
};

const translateKnownMessage = (message, t) => {
  if (!message) return t('apiErrors.default');

  const normalizedMessage = String(message).toLowerCase();

  if (
    normalizedMessage.includes('online ordering is disabled') ||
    normalizedMessage.includes('ordering is currently disabled')
  ) {
    return getTranslationOrFallback(
      t,
      'publicMenu.checkout.orderingDisabled',
      message,
    );
  }

  if (normalizedMessage.includes('unauthenticated')) {
    return t('apiErrors.unauthenticated');
  }

  if (
    normalizedMessage.includes('forbidden') ||
    normalizedMessage.includes('not allowed') ||
    normalizedMessage.includes('unauthorized')
  ) {
    return t('apiErrors.forbidden');
  }

  if (
    normalizedMessage.includes('not found') ||
    normalizedMessage.includes('no query results')
  ) {
    return t('apiErrors.notFound');
  }

  if (normalizedMessage.includes('validation')) {
    return t('apiErrors.validation');
  }

  if (normalizedMessage.includes('required')) {
    return t('validation.messages.required');
  }

  if (normalizedMessage.includes('numeric')) {
    return t('validation.messages.numeric');
  }

  if (normalizedMessage.includes('image')) {
    return t('validation.messages.image');
  }

  if (normalizedMessage.includes('mimes')) {
    return t('validation.messages.mimes');
  }

  if (normalizedMessage.includes('dimensions')) {
    return t('validation.messages.dimensions');
  }

  if (
    normalizedMessage.includes('less than') ||
    normalizedMessage.includes('lt')
  ) {
    return t('validation.messages.lessThanPrice');
  }

  if (normalizedMessage.includes('does not belong')) {
    return t('validation.messages.categoryOwnership');
  }

  return message;
};

export const translateApiError = (error, t) => {
  if (!error?.response) {
    return t('apiErrors.network');
  }

  const status = error.response.status;
  const data = error.response.data;
  const backendMessage =
    typeof data?.message === 'string' ? data.message.trim() : '';

  if (status === 401) {
    return t('apiErrors.unauthenticated');
  }

  if (status === 403) {
    return backendMessage
      ? translateKnownMessage(backendMessage, t)
      : t('apiErrors.forbidden');
  }

  if (status === 404) {
    return backendMessage
      ? translateKnownMessage(backendMessage, t)
      : t('apiErrors.notFound');
  }

  if (status >= 500) {
    return t('apiErrors.server');
  }

  if (status === 422 && data?.errors) {
    const translatedErrors = Object.entries(data.errors)
      .map(([field, messages]) => {
        const normalizedField = normalizeFieldName(field);

        const fieldLabel = getTranslationOrFallback(
          t,
          `validation.fields.${normalizedField}`,
          field,
        );

        const firstMessage = Array.isArray(messages)
          ? messages[0]
          : messages;

        return `${fieldLabel}: ${translateKnownMessage(firstMessage, t)}`;
      })
      .slice(0, 4);

    if (translatedErrors.length) {
      return translatedErrors.join('\n');
    }
  }

  return translateKnownMessage(backendMessage, t);
};

export default translateApiError;